import { render, staticRenderFns } from "./receipt-table.vue?vue&type=template&id=25a8bf69"
import script from "./receipt-table.vue?vue&type=script&lang=js"
export * from "./receipt-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports